module.exports = __webpack_public_path__ + "media/images/pic02-6330e908d78846c771e9d70db2d91535.jpg";